import { Box } from '@mui/material'
import { LinkStyled, NormalText } from '../styles'

// Footer comun a todas las pantallas. Antes solo estaba en el login y sin link.
export const Footer = () => (
  <Box
    display={'flex'}
    justifyContent={'center'}
    alignItems={'center'}
    gap={'4px'}
    padding={'16px 0'}
  >
    <NormalText>Developed by</NormalText>
    <LinkStyled
      href={'https://develone.com'}
      target={'_blank'}
      rel={'noopener noreferrer'}
      underline={'none'}
    >
      Develone
    </LinkStyled>
  </Box>
)
